import { render, staticRenderFns } from "./ProductKitComponent.vue?vue&type=template&id=3de9f79e"
import script from "./ProductKitComponent.vue?vue&type=script&lang=js"
export * from "./ProductKitComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports